var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import cx from 'classnames';
import * as React from 'react';
import performSearchAction from '../../action/performSearch';
import { useFluxible } from '../hooks/useFluxible';
export var SearchBox = function (_a) {
    var _b = _a.placeholder, placeholder = _b === void 0 ? 'Search for docs' : _b, _c = _a.text, text = _c === void 0 ? '' : _c, _d = _a.className, className = _d === void 0 ? '' : _d;
    var inputElRef = React.useRef(null);
    var _e = __read(React.useState(text), 2), textState = _e[0], setTextState = _e[1];
    var _f = __read(React.useState(false), 2), focused = _f[0], setFocused = _f[1];
    var executeAction = useFluxible().executeAction;
    React.useEffect(function () {
        setTextState(text);
    }, [text]);
    React.useEffect(function () {
        if (focused && inputElRef.current) {
            inputElRef.current.select();
        }
    }, [focused]);
    var handleSubmit = function (evt) {
        evt.preventDefault();
        if (inputElRef.current) {
            inputElRef.current.blur();
        }
        executeAction(performSearchAction, { query: textState });
    };
    return (React.createElement("div", { className: cx('form-group', 'search-control', focused ? 'focused' : '', className || '') },
        React.createElement("form", { id: "search", role: "search", className: "search-form", autoComplete: "off", onSubmit: handleSubmit },
            React.createElement("div", null,
                React.createElement("i", { className: "icon-budicon-489", onClick: function () { return setFocused(true); } }),
                React.createElement("input", { id: "search-input", ref: inputElRef, className: "search-input form-control", type: "text", placeholder: placeholder, value: textState, onChange: function (evt) { return setTextState(evt.target.value); }, onFocus: function () { return setFocused(true); }, onBlur: function () { return setFocused(false); } })))));
};
